import { useCallback } from "react";
import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useDeleteCollectEvent(org?: string) {
  const queryClient = useQueryClient();

  const handleDelete = useCallback(
    async (collectEventId: string) => {
      if (!collectEventId) {
        throw Error("Missing collect event ID.");
      }
      const res = await axios.delete(`/${org}/collectevents/${collectEventId}`);
      return res.data;
    },
    [org]
  );

  return useMutation({
    mutationFn: handleDelete,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["organization", org],
      });
    },
  });
}
